import { render } from "./ProgramCarousel.vue?vue&type=template&id=9119d7be&scoped=true"
import script from "./ProgramCarousel.vue?vue&type=script&lang=js"
export * from "./ProgramCarousel.vue?vue&type=script&lang=js"

import "./ProgramCarousel.vue?vue&type=style&index=0&id=9119d7be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9119d7be"]])

export default __exports__